var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1082,
    height: 936,
    viewBox: "0 0 1082 936",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M618.785 522.593L454.628 501.186L473.767 326.402L618.785 522.593ZM457.566 498.877L612.902 519.132L475.675 333.486L457.566 498.877Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M621.538 527.591L448.044 499.377L474.842 318.368L621.538 527.591ZM451.077 497.162L615.711 523.937L476.504 325.395L451.077 497.162Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M624.283 532.885L441.12 497.254L476.285 310.04L624.283 532.885ZM444.236 495.138L618.525 529.042L477.698 316.998L444.236 495.138Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M627.005 538.49L433.835 494.791L478.118 301.417L627.005 538.49ZM437.035 492.781L621.319 534.466L479.28 308.3L437.035 492.781Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M629.69 544.423L426.18 491.974L480.374 292.516L629.69 544.423ZM429.47 490.062L624.094 540.224L481.298 299.312L429.47 490.062Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M632.324 550.69L418.146 488.761L483.096 283.32L632.324 550.69ZM421.523 486.955L626.823 546.321L483.781 290.029L421.523 486.955Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M634.896 557.305L409.729 485.127L486.33 273.844L634.896 557.305ZM413.19 483.427L629.504 552.769L486.776 280.455L413.19 483.427Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M637.386 564.278L400.919 481.037L490.111 264.094L637.386 564.278ZM404.459 479.451L632.108 559.587L490.323 270.603L404.459 479.451Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M639.775 571.623L391.696 476.463L494.477 254.08L639.775 571.623ZM395.323 474.994L634.622 566.788L494.465 260.479L395.323 474.994Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M642.047 579.354L382.072 471.371L499.493 243.809L642.047 579.354ZM385.774 470.016L637.027 574.375L499.255 250.093L385.774 470.016Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M644.175 587.479L372.024 465.723L505.196 233.299L644.175 587.479ZM375.81 464.489L639.303 582.372L504.745 239.463L375.81 464.489Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M646.14 596.011L361.551 459.477L511.639 222.555L512.563 225.126L646.14 596.011ZM365.413 458.367L641.415 590.778L510.973 228.597L365.413 458.367Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M647.916 604.957L350.648 452.597L518.882 211.598L647.916 604.957ZM354.593 451.617L643.354 599.615L518.015 217.515L354.593 451.617Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M649.472 614.333L339.312 445.039L340.262 443.8L526.984 200.454L649.472 614.333ZM343.336 444.187L645.076 608.885L525.913 206.243L343.336 444.187Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M650.786 624.144L327.545 436.763L536.007 189.138L650.786 624.144ZM331.641 436.047L646.564 618.605L534.739 194.798L331.641 436.047Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M651.823 634.401L315.342 427.723L546.013 177.686L546.585 180.147L651.823 634.401ZM319.51 427.147L647.775 628.783L544.548 183.213L319.51 427.147Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M652.546 645.115L302.704 417.867L557.068 166.118L652.546 645.115ZM306.944 417.435L648.688 639.424L555.422 171.51L306.944 417.435Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M652.925 656.291L289.635 407.151L569.249 154.472L652.925 656.291ZM293.94 406.864L649.253 650.536L567.413 159.731L293.94 406.864Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M652.917 667.937L276.141 395.525L582.624 142.788L652.917 667.937ZM280.506 395.384L649.441 662.125L580.614 147.911L280.506 395.384Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M652.482 680.056L262.224 382.932L597.274 131.101L652.482 680.056ZM266.654 382.947L649.207 674.211L595.093 136.091L266.654 382.947Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M651.569 692.661L247.896 369.322L613.28 119.467L651.569 692.661ZM252.383 369.489L648.498 686.774L610.925 124.313L252.383 369.489Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M650.142 705.741L233.169 354.63L630.719 107.929L630.795 110.242L650.142 705.741ZM237.708 354.96L647.276 699.838L628.202 112.639L237.708 354.96Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M648.143 719.307L218.062 338.806L649.692 96.5454L648.143 719.307ZM222.647 339.298L645.485 713.39L647.003 101.119L222.647 339.298Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M645.519 733.353L202.584 321.786L670.276 85.3794L670.189 87.6473L645.519 733.353ZM207.211 322.437L643.069 727.431L667.429 89.8091L207.211 322.437Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M642.214 747.884L186.763 303.507L692.572 74.498L642.214 747.884ZM191.427 304.329L639.976 741.966L689.566 78.7877L191.427 304.329Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M638.17 762.885L170.623 283.907L716.679 63.9736L716.429 66.1999L638.17 762.885ZM175.321 284.896L636.145 756.987L713.521 68.1271L175.321 284.896Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M633.316 778.358L154.187 262.92L742.689 53.8906L633.316 778.358ZM158.912 264.079L631.499 772.482L739.384 57.9039L158.912 264.079Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M627.592 794.29L137.498 240.477L770.721 44.335L770.305 46.5194L627.592 794.29ZM142.242 241.806L625.983 788.445L767.261 48.2042L142.242 241.806Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M620.917 810.67L120.589 216.512L800.881 35.4004L800.377 37.5661L620.917 810.67ZM125.345 218.011L619.52 804.862L797.269 39.1259L125.345 218.011Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M613.22 827.476L611.584 825.432L103.499 190.948L833.267 27.1885L613.22 827.476ZM108.258 192.618L612.031 821.714L829.508 30.7703L108.258 192.618Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M604.421 844.694L86.2798 163.721L868.004 19.8159L867.323 21.9398L604.421 844.694ZM91.0389 165.561L603.436 838.989L864.097 23.2498L91.0389 165.561Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M594.434 862.3L68.9856 134.755L905.207 13.3955L594.434 862.3ZM73.7333 136.765L593.65 856.655L901.156 16.6818L73.7333 136.765Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M583.166 880.268L51.6716 103.973L53.8941 103.735L944.995 8.06006L944.132 10.1426L583.166 880.268ZM56.4042 106.154L582.587 874.692L940.804 11.1989L56.4042 106.154Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M570.528 898.563L34.4106 71.3036L987.497 3.94531L570.528 898.563ZM39.1168 73.651L570.146 893.058L983.158 6.93254L39.1168 73.651Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M556.418 917.156L17.2715 36.6713L1032.83 1.20703L556.418 917.156ZM21.9435 39.1816L556.228 911.727L1028.35 4.0392L21.9435 39.1816Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M540.735 936L0.332275 0H1081.13L540.735 936ZM4.96266 2.67295L540.732 930.654L1076.5 2.67295H4.96266Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.a1d9272eaab42c24224e1fce09893b28.svg";
export { ForwardRef as ReactComponent };